import moment from 'moment-timezone';

angular.module('ResearchKitApplicationModule').factory('predicateEvaluator', ["dateUtility", function (dateUtility) {
	var predicateEvaluators = [];
	predicateEvaluators["TruePredicate"] = function (predicate, managedResults) {
		return true;
	}
	predicateEvaluators["FalsePredicate"] = function (predicate, managedResults) {
		return false;
	}


	predicateEvaluators["BooleanQuestionResultPredicate"] = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'QuestionResult' || questionResult.Answer === undefined || questionResult.Answer === null || questionResult.Answer === '') { return false; }
		return predicate.expectedAnswer === (questionResult.Answer === 'true' || questionResult.Answer === 'True' || questionResult.Answer === true);
	}
	predicateEvaluators["ConsentPredicate"] = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'ConsentSignatureResult') { return false; }
		return predicate.didConsent === questionResult.Consented;
	}

	predicateEvaluators["WebViewResultPredicate"] = function (predicate, managedResults) {
		if (predicate.hasOwnProperty('expectedString') === predicate.hasOwnProperty('matchingPattern')) return false;

		var webViewResult = getResult(predicate, managedResults);
		if (!webViewResult || webViewResult.Type != 'WebViewStepResult') { return false; }

		if (predicate.hasOwnProperty('expectedString')) {
			return webViewResult.Result === predicate.expectedString;
		} else if (predicate.hasOwnProperty('matchingPattern')) {
			var regex = new RegExp(predicate.matchingPattern);
			return regex.test(webViewResult.Result);
		}
	};

	var numericPredicateEvaluator = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'QuestionResult') { return false; }

		var result = true;
		if (!_.isUndefined(predicate.expectedAnswer) && (_.isUndefined(questionResult.Answer) || predicate.expectedAnswer != questionResult.Answer)) {
			result = false;
		}
		if (!_.isUndefined(predicate.maximumExpectedAnswerValue) && (_.isUndefined(questionResult.Answer) || predicate.maximumExpectedAnswerValue < questionResult.Answer)) {
			result = false;
		}
		if (!_.isUndefined(predicate.minimumExpectedAnswerValue) && (_.isUndefined(questionResult.Answer) || predicate.minimumExpectedAnswerValue > questionResult.Answer)) {
			result = false;
		}
		return result;
	}
	predicateEvaluators["NumericQuestionResultPredicate"] = numericPredicateEvaluator;
	predicateEvaluators["ScaleQuestionResultPredicate"] = numericPredicateEvaluator;
	predicateEvaluators["TextQuestionResultPredicate"] = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'QuestionResult') { return false; }
		return questionResult.Answer === predicate.expectedString;
	}
	predicateEvaluators["ChoiceQuestionResultPredicate"] = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'QuestionResult') { return false; }
		var result = false;
		if (!_.isUndefined(questionResult.Choices)) {
			if (!_.isUndefined(predicate.expectedString)) {
				result = questionResult.Choices.indexOf(predicate.expectedString) != -1;
			}
			if (!_.isUndefined(predicate.expectedStrings)) {
				result = _.every(predicate.expectedStrings, function (expectedString) { return questionResult.Choices.indexOf(expectedString) != -1 });
			}
		}
		return result;
	}

	var datePredicateEvaluator = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'QuestionResult') { return false; }
		var result = true;
		if (!_.isUndefined(predicate.maximumExpectedDate) && moment(questionResult.Answer).isAfter(dateUtility.momentFromDateObjectOrString(predicate.maximumExpectedDate))) {
			result = false;
		}
		if (!_.isUndefined(predicate.minimumExpectedDate) && dateUtility.momentFromDateObjectOrString(predicate.minimumExpectedDate).isAfter(moment(questionResult.Answer))) {
			result = false;
		}
		return result;
	};
	var timePredicateEvaluator = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'QuestionResult') { return false; }
		var result = true;
		if (!_.isUndefined(predicate.maximumExpectedDate)) {
			if (dateUtility.relativeDateIsValid(predicate.maximumExpectedDate)) {
				if (moment(questionResult.Answer, "H:mm A").isAfter(moment(dateUtility.momentFromDateObjectOrString(predicate.maximumExpectedDate).format("H:mm A"), "H:mm A"))) {
					result = false;
				}
			} else if (moment(questionResult.Answer, "H:mm A").isAfter(moment(predicate.maximumExpectedDate.split("T")[1], "HH:mm:ss"))) {
				result = false;
			}
		}
		if (!_.isUndefined(predicate.minimumExpectedDate)) {
			if (dateUtility.relativeDateIsValid(predicate.minimumExpectedDate)) {
				if (moment(dateUtility.momentFromDateObjectOrString(predicate.minimumExpectedDate).format("H:mm A"), "H:mm A").isAfter(moment(questionResult.Answer, "H:mm A"))) {
					result = false;
				}
			} else if (moment(predicate.minimumExpectedDate.split("T")[1], "HH:mm:ss").isAfter(moment(questionResult.Answer, "H:mm A"))) {
				result = false;
			}
		}
		return result;
	};
	predicateEvaluators["DateQuestionResultPredicate"] = datePredicateEvaluator;
	predicateEvaluators["TimeOfDayQuestionResultPredicate"] = timePredicateEvaluator;
	predicateEvaluators["HeightWeightQuestionResultPredicate"] = numericPredicateEvaluator;

	predicateEvaluators["NilQuestionResultPredicate"] = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);

		// if question is skipped there will be no questionResult
		if (!questionResult) {
			return true;
		}

		// ResearchKit Documentation:
		// A question result has a `nil` answer if it was generated by a step that was skipped by
		// the user or if it was part of a form step and the question was left unanswered.

		// This checks for an actual answer (both question and form steps)
		if (questionResult.hasOwnProperty("Answer")) {
			if (_.isUndefined(questionResult.Answer) || questionResult.Answer === "" || questionResult.Answer === null) {
				return true;
			}
			return false;
		} else if (questionResult.hasOwnProperty("Choices")) {
			return questionResult.Choices === null || questionResult.Choices.length === 0;
		}
		return true;
	}
	predicateEvaluators["NotCompoundPredicate"] = function (predicate, managedResults) {
		return !evaluatePredicate(predicate.subpredicate, managedResults);
	}
	predicateEvaluators["OrCompoundPredicate"] = function (predicate, managedResults) {
		return _.some(predicate.subpredicates, function (sub) { return evaluatePredicate(sub, managedResults); });
	}
	predicateEvaluators["AndCompoundPredicate"] = function (predicate, managedResults) {
		return _.every(predicate.subpredicates, function (sub) { return evaluatePredicate(sub, managedResults); });
	}

	function evaluatePredicate(predicate, managedResults) {
		var evaluator = predicateEvaluators[predicate.type];
		if (!evaluator) {
			throw "Unsupported Predicate type: " + predicate.type;
		}
		var result = evaluator(predicate, managedResults);
		return result;
	}

	function getResult(predicate, managedResults) {
		var stepIdentifier = predicate.stepIdentifier != null ? predicate.stepIdentifier : predicate.resultIdentifier;
		var stepResult = managedResults[stepIdentifier];

		if (!stepResult) { return null; }
		for (var i = 0; i < stepResult.QuestionResults.length; i++) {
			if (stepResult.QuestionResults[i].Identifier == predicate.resultIdentifier) {
				return stepResult.QuestionResults[i];
			}
		}
		return null;
	}

	//only used in MyDataHelps Designer "try it out" mode
	predicateEvaluators["CustomFieldPredicate"] = function (predicate, managedResults) {
		return false;
	}
	predicateEvaluators["DemographicFieldPredicate"] = function (predicate, managedResults) {
		return false;
	}

	return {
		evaluatePredicate: evaluatePredicate
	};
}]);